import { useAxios } from "../../../../hooks/useAxios"
import { MaestrosAdapters } from "../adapters/maestros.adapters"

// Catálogos de empresas. Vienen del WS de empresas (`/integra-web`), no de este
// backoffice, así que la url se compone con la base de la API
// (`REACT_APP_API_URL`, que ya apunta a .../ebcnservices) en lugar de con una
// ruta relativa.
const API_URL = process.env.REACT_APP_API_URL || ''

// No requieren token, pero se llaman con `useAxios` para que el formato de la
// respuesta sea el mismo que en el resto del módulo.
const MaestrosServices = {

    // GET {REACT_APP_API_URL}/integra-web/categorias-publicas
    GET_CATEGORIAS_PUBLICAS: function () {

        return useAxios({
            method: 'get',
            url: `${API_URL}/integra-web/categorias-publicas`,
            type: 'json',
            adapters: MaestrosAdapters.GET_CATEGORIAS_PUBLICAS
        })
    },

    // GET {REACT_APP_API_URL}/integra-web/departamentos-publicos
    GET_DEPARTAMENTOS_PUBLICAS: function () {

        return useAxios({
            method: 'get',
            url: `${API_URL}/integra-web/departamentos-publicos`,
            type: 'json',
            adapters: MaestrosAdapters.GET_DEPARTAMENTOS_PUBLICAS
        })
    },
}

export {
    MaestrosServices
}